// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2YpOh","list":"PatternAutocomplete_list__1hfYV"};